module.exports = __webpack_public_path__ + "img/SW Task book NUMERACY-min.6de2638f.png";